import { render, staticRenderFns } from "./CustFee.vue?vue&type=template&id=4355b356&scoped=true&"
import script from "./CustFee.vue?vue&type=script&lang=js&"
export * from "./CustFee.vue?vue&type=script&lang=js&"
import style0 from "./CustFee.vue?vue&type=style&index=0&id=4355b356&scoped=true&lang=scss&"
import style1 from "./CustFee.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4355b356",
  null
  
)

export default component.exports